import React from 'react'
import { IconButton } from '@mui/material';
import YourLogo from './Logo.svg'

// Small presentational wrapper for the project logo used throughout the UI.
export const Logo = ({ width = 200, height = 50 }) => (
    <IconButton sx={{ borderRadius: 0, p: 0 }} aria-label="site logo">
        <img src={YourLogo} height={height} width={width} alt="Kingdom MMA" />
    </IconButton>
)